import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import CommentThread from '../../../CommentThread';
import ErrorBoundary from '../../../ErrorBoundary';
import DisabledComment from '../../../DisabledComment';
import { getCommentableTypeForDeviationType } from '../../redux/helpers';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import Premium from '@wix/da-ds/pkg/Icons/24x24/Premium';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/16x16/EyeDisc2';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import { getDeviationType, isImageDeviation, isTextualDeviation, } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import s from './Comments.scss';
export var COMMENTS_HTML_ID = 'comments';
export var Comments = function (_a) {
    var _b = _a.deviation, deviationId = _b.deviationId, typeId = _b.typeId, isCommentable = _b.isCommentable, hasPrivateComments = _b.hasPrivateComments, deviation = _a.deviation, isOwner = _a.isOwner, className = _a.className;
    var t = useTranslation().t;
    var post_comment_suggestions = useFlag('post_comment_suggestions');
    var commentableTypeId = getCommentableTypeForDeviationType(typeId);
    var _c = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData), isPremium = _c.isPremium, isPaidFolder = _c.isPaidFolder;
    var ownerInfo = isOwner && isPremium && hasPrivateComments && (React.createElement("div", { className: s['owner-info-wrapper'] },
        isPaidFolder ? (React.createElement(Premium, { size: IconSize.TINY })) : (React.createElement(EyeDisc2, { size: IconSize.TINY })),
        React.createElement("span", { className: s['owner-info'] }, t(isPaidFolder
            ? 'deviation.comments.paywallOwner.premium'
            : 'deviation.comments.paywallOwner.watchers_only'))));
    var isPoll = getDeviationType(deviation) === DeviationTypes.POLL;
    var withCommentSuggestions = isOwner
        ? undefined
        : isImageDeviation(deviation)
            ? 'deviation'
            : post_comment_suggestions && (isTextualDeviation(deviation) || isPoll)
                ? 'posts'
                : undefined;
    return (React.createElement(ErrorBoundary, { debugComponent: "Comments" },
        React.createElement(BiLoggerContextProvider, { value: { sectionname: 'comments' } },
            React.createElement("div", { className: s['comments-anchor'], id: COMMENTS_HTML_ID }),
            React.createElement(CommentThread, { key: "".concat(commentableTypeId, ":").concat(deviationId), commentableTypeId: commentableTypeId, commentableItemId: deviationId, postbox: isCommentable ? 'both' : 'none', statsAndControls: "on", className: className, allowSelfInit: false, enableOffsetTracking: true, extraInHeader: ownerInfo, withCommentSuggestions: withCommentSuggestions, isSticky: true }),
            !isCommentable && (React.createElement(DisabledComment, { className: classnames(s['comments-disabled'], className), title: t('deviation.comments.commentsDisabled') })))));
};
Comments.displayName = 'Comments';
export default Comments;
//# sourceMappingURL=Comments.js.map